export const authErrorMessage = (error, fallback = "Не удалось выполнить вход. Попробуйте ещё раз.") => {
  const status = error?.response?.status;
  if (!status) return "Не удалось связаться с приложением. Проверьте подключение и используйте основной адрес сайта. Пароль менять не нужно.";
  if (status >= 500) return "Сервис входа временно недоступен. Попробуйте позже — пароль менять не нужно.";
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string" && detail) return detail;
  if (detail && typeof detail.message === "string") return detail.message;
  if (Array.isArray(detail)) {
    const messages = detail.map(item => typeof item?.msg === "string" ? item.msg : "").filter(Boolean);
    if (messages.length) return messages.join("; ");
  }
  if (status === 429) return "Слишком много попыток входа. Подождите несколько минут.";
  if (status === 401) return fallback;
  if (status === 403) return "Вход недоступен для этой учётной записи. Свяжитесь с администратором.";
  return "Не удалось выполнить вход. Проверьте введённые данные и повторите попытку.";
};